import React, { Component } from "react";
import Chart from "chart.js";
import classes from "./Chart_Zodiac_RadarChart1.module.css";
import { findAllByDisplayValue } from "@testing-library/react";

const myZodiacLabel = [
    ['Aquarius', 'Urn'],
    ['Pisces', 'Lamp'],
    ['Aries', 'Rocking Chair'],
    ['Taurus', 'Bathtub'],
    ['Gemini', 'Closet'],
    ['Cancer', 'Table'],
    ['Leo', 'Sculpture'],
    ['Virgo', 'Harp'],
    ['Libra', 'Scale'],
    ['Scorpio', 'Lamp'],
    ['Saggitarius', 'Arrow'],
    ['Capricorn', 'Ornament']
];

export default class Chart_Zodiac_RadarChart extends Component {
    chartRef = React.createRef();

    componentDidMount() {
        const myChartRef = this.chartRef.current.getContext("2d"); 

        new Chart(myChartRef, {
            type: "radar",
            data: {
                //Bring in data
                labels: ['Gold', 'Star', 'Stone', 'Zodiac'],
                datasets: [
                    { label: ['Aquarius Urn'],  
                    data: [2,3,5,2],    		
                    backgroundColor: "rgba(252, 88, 0, 0.2)",
                        borderColor: "rgba(252, 88, 0, 1.0)",
                        borderWidth: 1 },
                    { label: ['Gemini Closet'],  
                        data: [2,3,6,2],    		
                        backgroundColor: "rgba(6, 0, 255, 0.2)",
                            borderColor: "rgba(6, 0, 255, 1.0)",
                            borderWidth: 1 },
                    { label: ['Libra Scale'],  
                        data: [2,3,0,2],    		
                        backgroundColor: "rgba(0, 252, 13, 0.2)",
                            borderColor: "rgba(0, 252, 13, 1.0)",
                            borderWidth: 1 }        
                ]
            },
            options: {
                responsive: true,
                maintainAspectRatio: false,
                legend: {
                    "display": true,
                    "labels": {
                        "fontSize": 10,
                    }
                },
                scale: {
                    ticks: {
                        min: 0
                    }
                }
              }
        });
        
    }
    render() {
        return (
            <div className={classes.graphContainer}>
                <canvas
                    id="myChart"
                    ref={this.chartRef}
                />
            </div>
        )
    }   
}    